import React, { MouseEvent } from 'react';
import { getComputedCSSVariable } from '../../../utils/cssVariableHelpers';

interface CityLinkProps {
  state: string,
  city: string;
  onClick: (city: string) => void;
}

const CityLink: React.FC<CityLinkProps> = ({ state, city, onClick }) => {
  const onClickHandler = (e: MouseEvent) => {
    e.preventDefault();
    onClick(city);
  };

  const cityUrlParam = city.replace(/ /g, '-').toLowerCase();

  return (
    <a
      href={`?state=${state}&city=${cityUrlParam}`}
      className="btn btn-sm rounded-pill text-center d-flex my-3 px-3 align-items-center"
      style={{
        gap: '0.5rem',
        backgroundColor: getComputedCSSVariable('blue-200'),
        borderColor: getComputedCSSVariable('blue-200'),
        fontSize: '1rem',
        margin: '0 0.125rem',
      }}
      onClick={onClickHandler}
    >
      {city}
    </a>
  );
};

export default CityLink;
